import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import ICalendar from '../../../_interfaces/ICalendar';
import ICalendarNote from '../../../_interfaces/ICalendarNote';
import { SessionService } from '../../../_services/session/session.service';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CommonModule } from '@angular/common';
import { SelectorCalendarComponent } from '../../selectors/selector-calendar/selector-calendar.component';
import { FormBase } from '../../../_classes/form-base.class';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { CalendarNotesService } from '../../../_services/calendar-notes/calendar-notes.service';
import { ValidatorService } from '../../../_services/validators/validator.service';
import { DeleteButtonCalendarNoteComponent } from '../../delete-buttons/delete-button-calendar-note/delete-button-calendar-note.component';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextarea } from 'primeng/inputtextarea';
import { EResources } from '../../../_resources/EResources';

@Component({
  standalone: true,
  selector: 'app-form-calendar-note',
  templateUrl: './form-calendar-note.component.html',
  styleUrls: ['./form-calendar-note.component.scss'],
  imports: [
    SelectorCalendarComponent,
    TranslatePipe,

    FormsModule,
    CheckboxModule,
    ButtonModule,
    CommonModule,
    DatePickerModule,
    DeleteButtonCalendarNoteComponent,
    InputTextModule,
    InputTextarea,
  ],
})
export class FormCalendarNoteComponent
  extends FormBase<ICalendarNote>
  implements OnInit
{
  @Input('onRemove')
  onRemove: () => void;

  public includeHours: boolean = false;

  constructor(
    public translate: TranslateService,
    public session: SessionService,
    public messageService: MessageService,
    public calendarNotesService: CalendarNotesService,
    public validator: ValidatorService
  ) {
    super(session, messageService, translate);
  }

  clear(): void {
    this.payload = {
      title: undefined,
      calendars_id: undefined,
      description: undefined,
      date: moment().toDate(),
      dates: [moment().toDate()],
      start: undefined,
      end: undefined,
    };
  }

  generatePayload(): ICalendarNote {
    return {
      calendars_id: this.payload.calendars_id,
      date: moment(this.payload.date)
        .hour(0)
        .minute(0)
        .seconds(0)
        .millisecond(0)
        .utc()
        .toDate(),
      title: this.payload.title,
      description: this.payload.description,
      start:
        this.payload.start && this.includeHours
          ? moment(this.payload.start).utc().format('HH:mm')
          : undefined,
      end:
        this.payload.end && this.includeHours
          ? moment(this.payload.end).utc().format('HH:mm')
          : undefined,
      dates: this.payload.dates,
    };
  }

  getResourceName(): string {
    return EResources.CALENDAR_NOTES;
  }
  updateFn(payload: ICalendarNote): Observable<any> {
    return this.calendarNotesService.update(
      this.customers_id,
      this.sites_id,
      this.id,
      payload
    );
  }
  createFn(payload: ICalendarNote): Observable<any> {
    return this.calendarNotesService.create(
      this.customers_id,
      this.sites_id,
      payload
    );
  }
  properties(): string[] {
    return ['title', 'calendars_id', 'description', 'date', 'start', 'end'];
  }
  validate(): Promise<void> {
    return this.validator.calendarNote(this.payload);
  }

  public handleCalendarChange = (calendar: ICalendar) => {
    this.payload.calendars_id = calendar.id;
  };

  checkPermissions(): boolean {
    if (this.mode == 'create') {
      return this.hasPermission('CALENDAR_NOTES.CREATE');
    } else {
      return this.hasPermission('CALENDAR_NOTES.UPDATE');
    }
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.payload.date = moment(this.payload.date).toDate();
    if (this.payload.start && this.payload.end) {
      this.includeHours = true;
      const dateString = moment(this.payload.date).format('YYYY-MM-DD');
      this.payload.start = moment
        .utc(`${dateString} ${this.payload.start}`)
        .toDate();
      this.payload.end = moment
        .utc(`${dateString} ${this.payload.end}`)
        .toDate();
    }
  }
}
